import { configureStore } from "@reduxjs/toolkit";
import { myApi } from "./api";

export const store = configureStore({
  reducer: { [myApi.reducerPath]: myApi.reducer },
  middleware: (getDefault) => getDefault().concat(myApi.middleware),
});
